






























import { defineComponent, getCurrentInstance, onMounted } from "vue";

export default defineComponent({
  setup() {
    const context = getCurrentInstance().proxy;

    onMounted(() => {
      context.$root.$emit("hide-loading");
    });

    const steps = [
      {
        title: "Responda ao questionário online em cerca de 5 minutos.",
        text: "Perguntas simples sobre sua saúde e hábitos de vida, como em um bate-papo."
      },
      {
        title: "Envie seus exames recentes",
        text: "Faça o upload dos seus exames ou permita que a plataforma acesse os resultados direto dos laboratórios."
      },
      {
        title: "Pedido inteligente",
        text: "O sistema analisa o que você já fez e solicita apenas o necessário, sem repetições."
      },
      {
        title: "Resultados explicados",
        text: "Você recebe tudo traduzido de forma simples e clara, com encaminhamento médico personalizado."
      },
      {
        title: "Cuidado contínuo",
        text: "Além de orientações e encaminhamentos personalizados, a equipe de saúde Omint acompanha você em casos que precisem de atenção."
      }
    ];

    return { steps };
  }
});
